'use client';

import { TabButton, TabList, useTab } from '@publishing/components/ui/Tab';

import s from '../page.module.scss';

export function HubEventTabList() {
  const { tabs } = useTab();

  return (
    <div className={s.tab_wrap}>
      <h1 className="blind">이벤트 페이지</h1>
      <TabList className={s.tab_list} aria-label="이벤트 카테고리">
        {tabs.map((tab, index) => (
          <li key={String(tab.text)} role="presentation">
            <TabButton index={index} className={s.tab_button}>
              {tab.text}
            </TabButton>
          </li>
        ))}
      </TabList>
    </div>
  );
}
